import { Component, Input, OnInit } from '@angular/core';
import { ApiService } from 'src/app/shared/service/api.service';

@Component({
  selector: 'app-informative-salers',
  templateUrl: './informative-salers.component.html',
  styleUrls: ['./informative-salers.component.css']
})
export class InformativeSalersComponent implements OnInit {
  _filterAccomplish: any = {};
  @Input() set filterAccomplish(value: any) {
    this._filterAccomplish = value;
    this.filterItem(this._filterAccomplish);
  }

  dataItem = {
    chart: {
      lowerlimit: "0",
      upperlimit: "100",
      showvalue: "1",
      numbersuffix: "%",
      theme: "gammel",
      showtooltip: "0",
      captionPadding: "0",
      chartLeftMargin: "0",
      chartTopMargin: "0",
      chartRightMargin: "0",
      chartBottomMargin: "0"
    },
    colorrange: {
      color: [
        {
          minvalue: "0",
          maxvalue: 0,
          code: "#0C9ABE"
        },
        {
          minvalue: 0,
          maxvalue: "100",
          code: "#dbf7ff"
        }
      ]
    },
    dials: {
      dial: [
        {
          value: 0
        }
      ]
    }
  };

  width = "100%";
  height = "110";
  type = "angulargauge";
  dataFormat = "json";
  dataSource = this.dataItem;

  tm!: any;
  tmSplit!: any;
  pmpv!: any;
  pmpvSplit!: any;
  pa!: any;
  pu!: any;
  total!: any;
  totalSplit!: any;
  averageDiscount!: any;
  metaSale!: any;
  metaSaleSplit!: any;
  metaBoardEmpresa!: any;
  metaBoardMeta!: any;
  metaBoardPeriodoInicio!: any;
  metaBoardPeriodoFim!: any;
  topTooltip: string = 'Informações de configuração';

  constructor(private api: ApiService) { }

  ngOnInit(): void {
  }

  openInfo() {
    const metaItem : any = document.getElementById('meta');
    const metaInfoItem : any = document.getElementById('metaInfo');

    metaItem.style.display = 'none';
    metaInfoItem.style.display = 'inline';
  }

  closeInfo() {
    const metaItem : any = document.getElementById('meta');
    const metaInfoItem : any = document.getElementById('metaInfo');

    metaInfoItem.style.display = 'none';
    metaItem.style.display = 'inline';
  }

  filterItem(item: any) {
    if (item.branch != undefined) {
      this.metaBoard(item.branch);
      this.informativeTotals(item).subscribe(data => {
        if (data.dataRow.length > 0) {
          this.tm = parseFloat(data.dataRow[0].tm).toLocaleString('pt-BR', { minimumFractionDigits: 2 });
          this.pmpv = parseFloat(data.dataRow[0].pmpv).toLocaleString('pt-BR', { minimumFractionDigits: 2 });
          this.pa = data.dataRow[0].pa;
          this.pu = data.dataRow[0].pu;
          this.total = parseFloat(data.dataRow[0].invoice_value).toLocaleString('pt-BR', { minimumFractionDigits: 2 });
          this.averageDiscount = data.dataRow[0].average_discount;
          this.exibitionItem();
        }
      });
    }
  }

  metaBoard(item: any) {
    let dates = this.getStartAndEndOfCurrentMonth();
    let meta = 0;
    this.informativeTarget(this.formatDate(dates.diaInicial), this.formatDate(dates.diaFinal), item).subscribe(data => {
      if (data.dataRow.length > 0) {
        this.metaBoardEmpresa = data.dataRow[0].branch;
        this.metaBoardMeta = data.dataRow[0].salesTargetDescription;
        this.metaBoardPeriodoInicio = this.formatDateBrazil(dates.diaInicial);
        this.metaBoardPeriodoFim = this.formatDateBrazil(dates.diaFinal);
        meta = data.dataRow[0].salesTargetValue
        this.metaSale = parseFloat(data.dataRow[0].salesTargetValue).toLocaleString('pt-BR', { minimumFractionDigits: 2 });
        
        this.exibitionItem();

        let itemTotals = {
          branch: item,
          dataMax: this.formatDate(dates.dataAtual),
          dataMin: this.formatDate(dates.diaInicial),
        }
        this.informativeTotals(itemTotals).subscribe(data => {
          let percentageMeta = (data.dataRow[0].invoice_value / meta) * 100;
          this.dataItem.dials.dial[0].value = percentageMeta;
          this.dataItem.colorrange.color[0].maxvalue = percentageMeta;
          this.dataItem.colorrange.color[1].minvalue = 100 - percentageMeta;
        });
      }
    });
  }

  getStartAndEndOfCurrentMonth(): { dataAtual: Date; diaInicial: Date; diaFinal: Date } {
    const dataAtual = new Date();
    const diaInicial = new Date(dataAtual.getFullYear(), dataAtual.getMonth(), 1);
    const diaFinal = new Date(dataAtual.getFullYear(), dataAtual.getMonth() + 1, 0);

    return {
      dataAtual,
      diaInicial,
      diaFinal
    };
  }

  formatDate(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  formatDateBrazil(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${day}/${month}/${year}`;
  }

  exibitionItem() {
    let splitItemMeta = this.metaSale?.split('.');
    if (splitItemMeta?.length == 3) {
      this.metaSaleSplit = splitItemMeta[0] + 'M'
    } else if (splitItemMeta?.length == 2) {
      this.metaSaleSplit = splitItemMeta[0] + 'K'
    } else {
      this.metaSaleSplit = this.metaSale;
    }

    let splitItemPmpv = this.pmpv?.split('.');
    if (splitItemPmpv?.length == 3) {
      this.pmpvSplit = splitItemPmpv[0] + 'M'
    } else if (splitItemPmpv?.length == 2) {
      this.pmpvSplit = splitItemPmpv[0] + 'K'
    } else {
      this.pmpvSplit = this.pmpv;
    }

    let splitItemTm = this.tm?.split('.');
    if (splitItemTm?.length == 3) {
      this.tmSplit = splitItemTm[0] + 'M'
    } else if (splitItemTm?.length == 2) {
      this.tmSplit = splitItemTm[0] + 'K'
    } else {
      this.tmSplit = this.tm;
    }

    let splitItemTotal = this.total?.split('.');
    if (splitItemTotal?.length == 3) {
      this.totalSplit = splitItemTotal[0] + 'M'
    } else if (splitItemTotal?.length == 2) {
      this.totalSplit = splitItemTotal[0] + 'K'
    } else {
      this.totalSplit = this.total;
    }
  }

  informativeTotals(item: any) {
    return this.api.postTotalSellerPanel(item.dataMin, item.dataMax, item.branch);
  }

  informativeTarget(diaInicial: string, diaFinal: string, branch: any) {
    return this.api.postTargetSellerPanel(diaInicial, diaFinal, branch);
  }

}
